<template>
  <div class="user-page full-height">
    <table-con :canReturn="canReturn">
      <!-- <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/FBA'}">装箱单管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: 'boxList?containerBatchNo='+containerBatchNo}">装箱单详情</el-breadcrumb-item>
          <el-breadcrumb-item>箱子详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('fba.orderNo')}}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.orderNo" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('fba.stocktakeState')}}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.checkStatus" :placeholder="$t('fba.stocktakeState')" size="small" clearable>
                <el-option key="" value="" :label="$t('common.all')"></el-option>
                <el-option key="0" value="0" :label="$t('fba.notStocktake')"></el-option>
                <el-option key="1" value="1" :label="$t('fba.stocktakeResolve')"></el-option>
                <el-option key="2" value="2" :label="$t('fba.stocktakeReject')"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="query-title">{{$t('fba.packDate')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="orderDateRangeValue" type="daterange" range-separator="~"
                :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" @change="orderDateRange" size="small">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('common.reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('common.search')}}</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.packNo')}}:</div>
            <div class="query-content">{{boxInfo.boxNo}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.batchNo')}}:</div>
            <div class="query-content">{{boxInfo.containerBatchNo}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.goodsNumber')}}:</div>
            <div class="query-content">{{boxInfo.boxGoodsCount}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.goodsNetWeight')}}:</div>
            <div class="query-content">{{boxInfo.totalNetWeight}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.boxRealWeight')}}:</div>
            <div class="query-content">{{boxInfo.realWeight}}</div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('fba.boxThrowWeight')}}:</div>
            <div class="query-content">
              {{boxInfo.boxLong}}*{{boxInfo.boxWidth}}*{{boxInfo.boxHeight}}/{{boxInfo.boxDivisor}}={{boxInfo.throwWeight}}</div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border stripe
          style="width: 100%" height="550">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="orderNo" align="center" :label="$t('fba.orderNo')"></el-table-column>
          <el-table-column prop="createTime" align="center" :label="$t('fba.packDate')" width="160" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="createUserName" align="center" :label="$t('fba.packPerson')"></el-table-column>
          <el-table-column prop="orderCreateTime" width="160" :label="$t('fba.orderDate')" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="boxGoodsCount" align="center" :label="$t('fba.packNumber')"></el-table-column>
          <el-table-column prop="throwWeight" align="center" :label="$t('OrderDetail.OrderDetail9')"></el-table-column>
          <el-table-column prop="realWeight" align="center" :label="$t('fba.solidWeight')"></el-table-column>
          <el-table-column prop="materialName" align="center" :label="$t('OrderDetail.OrderDetail5')"></el-table-column>
          <el-table-column prop="goodsNameCus" align="center" :label="$t('fba.productName')" width="180">
            <template v-slot="scope">
              <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="fnsku" align="center" :label="$t('fba.fba11')"></el-table-column>
          <el-table-column prop="colour" align="center" :label="$t('fba.color')"></el-table-column>
          <el-table-column prop="goodsSize" align="center" :label="$t('fba.size')"></el-table-column>
          <el-table-column prop="totalNetWeight" align="center" :label="$t('fba.netWeight')">
                      <template v-slot="scope">
            <div>
              {{scope.row.netWeight.toFixed(3)}}
            </div>

          </template>
          </el-table-column>
          <el-table-column prop="checkStatus" align="center" :label="$t('fba.stocktakeState')">
            <template v-slot="scope">
              {{scope.row.checkStatus | checkStatusFilter}}
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
      </div>
    </table-con>
  </div>
</template>

<script>

import tableCon from '../../views/tableContainer'
export default {
  data () {
    return {
      boxInfo: {
        boxNo: '',
        containerBatchNo: '',
        boxGoodsCount: 0,
        totalNetWeight: 0.0,
        realWeight: 0.0,
        throwWeight: 0.0,
        boxLong: 0,
        boxWidth: 0,
        boxHeight: 0,
        boxDivisor: 0,
      },
      canReturn: '1',
      pageTitle: this.$t('fba.packDetail'),
      queryInfo: {
        boxNo: '',
        orderNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 9999,
        pageNum: 1,
      },
      containerBatchNo: '',
      orderDateRangeValue: [],
      orderList: [],
      total: 0
    };
  },
  components: { tableCon },
  methods: {
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    orderDateRange () {
    },
    queryInfoClear () {
      this.queryInfo = {
        boxNo: this.queryInfo.boxNo,
        orderNo: '',
        createTimeStart: '',
        createTimeEnd: '',
        checkStatus: '',
        pageSize: 9999,
        pageNum: 1,
      }
      this.orderDateRangeValue = [];
    },
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getOrderList();
    },
    async getOrderList () {
      const { data: res } = await this.$http.get("box/boxOrderlist", { params: this.queryInfo });
      this.orderList = res.data.list;
      console.log(this.orderList);
      this.total = res.data.total;
    },
    async getBoxInfo () {
      const { data: res } = await this.$http.get('box/getBoxInfo/' + this.queryInfo.boxNo);
      this.boxInfo = res.data;
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
    },

  },
  watch: {
    //监听时间选择器绑定值变化
    orderDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.orderDateRangeValue) {
        this.orderDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      }
      else {
        if (this.orderDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
          this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
        }
      }

    },
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem('token')) {
        return false;
      }
    }
  },
  created () {
    this.queryInfo.boxNo = this.$route.query.boxNo;
    this.containerBatchNo = this.$route.query.containerBatchNo;
    this.getOrderList();
    this.getBoxInfo();
  },
};
</script>

<style lang="less" scoped>
.query-content {
  margin-top: 5px;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.split-col {
  padding-right: 20px;
}
.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}
/deep/ .el-textarea__inner {
  color: #606266 !important;
}
</style>
